<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
        <v-layout wrap>
            <v-flex xs12>
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between class="py-2">
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="student && student.familyID"
                            >
                                <div
                                    class="display-1 font-weight-bold mb-0 ml-0"
                                >
                                    {{
                                        student.hebName +
                                            " " +
                                            student.lastNameH
                                    }}
                                </div>
                                <div class="ml-0 mt-4">
                                    <div class="pl-2">
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Family ID:
                                            </div>
                                            <div>
                                                {{ student.familyID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Student ID:
                                            </div>
                                            <div>
                                                {{ student.studentID }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Father:
                                            </div>
                                            <div>
                                                {{ student.hname }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Branch:
                                            </div>
                                            <div>
                                                {{ student.branch }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Grade:
                                            </div>
                                            <div>
                                                {{ student.class }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Section:
                                            </div>
                                            <div>
                                                {{ student.section }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Teacher:
                                            </div>
                                            <div>
                                                {{ student.teacherDescription }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Building:
                                            </div>
                                            <div>
                                                {{ student.building }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Address:
                                            </div>
                                            <div>
                                                {{ student.address1 }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Home Phone:
                                            </div>
                                            <div>
                                                {{ student.homePhone }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Cell Phone:
                                            </div>
                                            <div>
                                                {{ student.cellPhone }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2 ml-0"
                                            v-if="info.mother"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Mother:
                                            </div>
                                            <div>
                                                {{ info.mother }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2 pl-0 ml-0"
                                            v-if="info.motherCellphone"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Mother Cellphone:
                                            </div>
                                            <div>
                                                {{ info.motherCellphone }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-0 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Updated At:
                                            </div>
                                            <div>
                                                {{ info.updatedAt | time }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2 pl-0 ml-0">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Updated By:
                                            </div>
                                            <div>
                                                {{ info.updatedBy }}
                                            </div>
                                        </v-layout>
                                        <v-btn
                                            class="mb-3 mr-1 mt-2"
                                            color="success"
                                            small
                                            dark
                                            @click="openEditDialog()"
                                        >
                                            Edit
                                        </v-btn>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-layout>
                        <v-layout column class="ma-1 px-3">
                            <v-card-text
                                class="mb-0 pb-0 pt-2 pl-2"
                                v-if="student && student.familyID"
                            >
                                <div class="ml-0 mt-3">
                                    <div class="pl-3">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Date Entered:
                                            </div>
                                            <div>
                                                {{ info.dateEntered | time }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Referral:
                                            </div>
                                            <div>
                                                {{ info.referral }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Concern:
                                            </div>
                                            <div>
                                                {{ info.concern }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Evaluated By:
                                            </div>
                                            <div>
                                                {{ info.evaluatedBy }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Evaluation Date:
                                            </div>
                                            <div>
                                                {{ info.evaluationDate | date }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Evaluation Outcome:
                                            </div>
                                            <div>
                                                {{ info.evaluationOutcome }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Other Recommendations:
                                            </div>
                                            <div>
                                                {{ info.otherRecommendations }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Parents Input:
                                            </div>
                                            <div>
                                                {{ info.parentsInput }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Teachers Input:
                                            </div>
                                            <div>
                                                {{ info.teachersInput }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Process:
                                            </div>
                                            <div>
                                                {{ info.process }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Provider:
                                            </div>
                                            <div>
                                                {{ info.provider }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Work Status:
                                            </div>
                                            <div>
                                                {{ info.workStatus }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Status:
                                            </div>
                                            <div>
                                                {{ info.status }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Status Reason:
                                            </div>
                                            <div>
                                                {{ info.statusReason }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Time Of Service:
                                            </div>
                                            <div>
                                                {{ info.timeOfService }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Room Number:
                                            </div>
                                            <div>
                                                {{ info.roomNumber }}
                                            </div>
                                        </v-layout>
                                        <v-layout row class="mb-3">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Work Done:
                                            </div>
                                            <div>
                                                {{ info.workDone }}
                                            </div>
                                        </v-layout>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <!-- <v-spacer></v-spacer>

                    <v-layout
                        align-start
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click=""
                        >
                            Edit
                        </v-btn>
                    </v-layout> -->
                </v-card>
            </v-flex>

            <v-flex xs8>
                <v-card
                    class="pa-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#actions">
                            Workplans ({{ actions.length }})
                            <v-icon>mdi-gesture-double-tap</v-icon>
                        </v-tab>

                        <v-tab href="#progress">
                            Progress ({{ progressReportCount }})
                            <v-icon>mdi-progress-clock</v-icon>
                        </v-tab>

                        <v-tab href="#documents">
                            Documents ({{ documents.length }})
                            <v-icon>mdi-file-multiple</v-icon>
                        </v-tab>

                        <v-tab-item value="actions">
                            <v-btn color="success" small @click="addAction"
                                >Add Workplan</v-btn
                            >
                            <v-expansion-panel v-if="actionsToDisplay.length">
                                <v-expansion-panel-content
                                    class=""
                                    v-for="action in actionsToDisplay"
                                >
                                    <template v-slot:header class="my-0">
                                        <v-flex xs2
                                            ><div
                                                class="subheading mb-1 font-weight-medium"
                                            >
                                                {{ action.date | date }}
                                            </div></v-flex
                                        >
                                        <v-flex xs5>
                                            <div class="text--disabled">
                                                {{
                                                    truncateDescription(
                                                        action.description,
                                                        100
                                                    )
                                                }}
                                            </div>
                                        </v-flex>

                                        <v-flex xs2>
                                            <v-layout row class="ma-0 pa-0">
                                                <v-icon
                                                    v-if="
                                                        getActionDocuments(
                                                            action
                                                        ).length
                                                    "
                                                    color="rgb(33, 150, 243)"
                                                    >mdi-file-multiple</v-icon
                                                >
                                                <div
                                                    class="ml-2"
                                                    v-if="
                                                        getActionDocuments(
                                                            action
                                                        ).length
                                                    "
                                                >
                                                    {{
                                                        getActionDocuments(
                                                            action
                                                        ).length +
                                                            " " +
                                                            pluralize(
                                                                "Document",
                                                                getActionDocuments(
                                                                    action
                                                                ).length
                                                            )
                                                    }}
                                                </div>
                                            </v-layout>
                                        </v-flex>

                                        <div
                                            class="subheading text-xs-right pr-3 font-weight-medium"
                                        >
                                            {{ action.title }}
                                        </div>
                                    </template>
                                    <v-card class="mx-3 pb-3 mt-3">
                                        <v-layout
                                            row
                                            justify-space-between
                                            align-end
                                            class="pa-0 ma-0"
                                        >
                                            <div>
                                                <v-layout row class="px-3 py-1">
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Description:
                                                    </div>
                                                    <div>
                                                        {{ action.description }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="px-3 py-1">
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Results:
                                                    </div>
                                                    <div>
                                                        {{ action.results }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="px-3 py-1">
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Updated By:
                                                    </div>
                                                    <div>
                                                        {{ action.updatedBy }}
                                                    </div>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    class="px-3 pt-1 pb-2"
                                                >
                                                    <div
                                                        class="font-weight-medium mr-2 width-200"
                                                    >
                                                        Updated At:
                                                    </div>
                                                    <div>
                                                        {{
                                                            action.updatedAt
                                                                | time
                                                        }}
                                                    </div>
                                                </v-layout>

                                                <div
                                                    class="mt-0 px-3"
                                                    v-if="
                                                        documents &&
                                                            getActionDocuments(
                                                                action
                                                            ).length
                                                    "
                                                >
                                                    <!-- <div
                                                class="font-weight-medium mb-0 layout row"
                                            >
                                                Documents
                                            </div> -->
                                                    <v-layout
                                                        column
                                                        class="mt-2"
                                                    >
                                                        <div
                                                            v-for="actionDocument in getActionDocuments(
                                                                action
                                                            )"
                                                        >
                                                            <v-btn
                                                                class="mt-2 ml-0 px-3"
                                                                @click="
                                                                    openDocument(
                                                                        actionDocument
                                                                    )
                                                                "
                                                            >
                                                                <v-icon
                                                                    :color="
                                                                        getFileIconColor(
                                                                            actionDocument
                                                                        )
                                                                    "
                                                                    left
                                                                    dark
                                                                    >{{
                                                                        getFileIcon(
                                                                            actionDocument
                                                                        )
                                                                    }}</v-icon
                                                                >
                                                                {{
                                                                    actionDocument.description +
                                                                        " - " +
                                                                        actionDocument.date
                                                                }}
                                                                <v-icon right
                                                                    >mdi-download</v-icon
                                                                >
                                                            </v-btn>
                                                            <v-btn
                                                                small
                                                                icon
                                                                @click.stop="
                                                                    openDeleteDocumentDialog(
                                                                        actionDocument
                                                                    )
                                                                "
                                                                ><v-icon
                                                                    color="red"
                                                                    >mdi-delete-forever</v-icon
                                                                ></v-btn
                                                            >
                                                        </div>
                                                    </v-layout>
                                                </div>
                                            </div>

                                            <v-spacer></v-spacer>

                                            <v-layout
                                                row
                                                justify-end
                                                class="ma-0 pa-0"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    small
                                                    dark
                                                    color="default"
                                                    class="mb-0 mr-2"
                                                    style="height: 28px;"
                                                    @click="
                                                        openUploadDocumentDialog(
                                                            action
                                                        )
                                                    "
                                                    >Upload Document<v-icon
                                                        right
                                                        dark
                                                        >mdi-cloud-upload</v-icon
                                                    ></v-btn
                                                >
                                                <v-btn
                                                    small
                                                    color="success"
                                                    class="mb-0"
                                                    style="height: 28px;"
                                                    @click="
                                                        updateAction(action)
                                                    "
                                                    >Update</v-btn
                                                >
                                            </v-layout>
                                        </v-layout>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-layout justify-center class="mt-3 mb-1">
                                <v-pagination
                                    v-model="actionsPagination.page"
                                    :length="actionsPages"
                                    :total-visible="5"
                                    v-on:input="setActionsPagianation"
                                ></v-pagination>
                            </v-layout>
                        </v-tab-item>
                        <v-tab-item value="progress">
                            <data-grid
                                v-if="progressUrl"
                                class="simple-datagrid"
                                :hideHeader="true"
                                :url="progressUrl"
                                :columns="progressColumns"
                                title="Progress"
                                :actions="progressActions"
                                :sortOptions="{
                                    enabled: true,
                                    field: 'date',
                                    type: 'desc',
                                }"
                                ref="progressGrid"
                                navigationPath="onRowClicked"
                                navigationField="onRowClicked"
                                :onRowClicked="editProgressReport"
                                :selectionEnabled="true"
                            ></data-grid>
                        </v-tab-item>
                        <v-tab-item value="documents" class="pb-3">
                            <v-btn
                                color="success"
                                class="mb-0"
                                small
                                @click="openUploadDocumentDialog"
                                >Upload Document</v-btn
                            >
                            <v-btn
                                class="ml-2 mb-0"
                                small
                                @click="openDeleteMultipleDocumentDialog()"
                                v-if="documents.some((d) => d.selected)"
                                color="success"
                                >Delete Documents</v-btn
                            >
                            <v-layout row wrap class="pl-1">
                                <div v-for="uploadedDocument in documents">
                                    <div
                                        class="spacial-needs-document mx-2 mt-3"
                                        @click="openDocument(uploadedDocument)"
                                    >
                                        <v-layout
                                            class="pa-0 ma-0"
                                            align-space-between
                                            column
                                            fill-height
                                        >
                                            <div
                                                class="mb-1 font-weight-medium"
                                                style="font-size: 11px"
                                                v-if="
                                                    allowDeleteDocument(
                                                        uploadedDocument
                                                    )
                                                "
                                            >
                                                <input
                                                    type="checkbox"
                                                    v-model="
                                                        uploadedDocument.selected
                                                    "
                                                    @click.capture.stop=""
                                                    class="mr-1"
                                                    style="width:12px; height:12px; color: rgb(76, 175, 80);"
                                                />
                                            </div>
                                            <div
                                                class="mb-0 font-weight-light"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    uploadedDocument.date | date
                                                }}
                                            </div>
                                            <!-- <div
                                                class="mb-1 font-weight-regular text-info"
                                                style="font-size: 11px"
                                            >
                                                {{
                                                    uploadedDocument.uploadedBy
                                                }}
                                            </div> -->
                                            <v-spacer></v-spacer>
                                            <v-layout
                                                class="pa-0 ma-0"
                                                row
                                                align-end
                                                justify-space-between
                                            >
                                                <div
                                                    class="font-weight-medium"
                                                    style="font-size: 12px"
                                                    :title="
                                                        uploadedDocument.description
                                                    "
                                                >
                                                    {{
                                                        truncateDescription(
                                                            uploadedDocument.description
                                                        )
                                                    }}
                                                </div>
                                                <v-icon
                                                    :color="
                                                        getFileIconColor(
                                                            uploadedDocument
                                                        )
                                                    "
                                                    >{{
                                                        getFileIcon(
                                                            uploadedDocument
                                                        )
                                                    }}</v-icon
                                                >
                                            </v-layout>
                                        </v-layout>
                                    </div>
                                </div>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
            <v-flex xs4
                ><notes
                    class="spacial-needs-notes"
                    v-if="notesUrl"
                    :loadUrl="notesUrl"
                    :accountID="student.familyID"
                    :studentID="student.studentID"
                    :isExpanded="true"
                    type="SPECIAL_NEEDS"
                ></notes
            ></v-flex>
        </v-layout>
        <v-dialog persistent v-model="updateActionDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">{{
                    actionToUpdate.id ? "Update Action" : "Add Action"
                }}</v-card-title>
                <v-menu
                    v-model="actionToUpdate.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="actionToUpdate.date"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="actionToUpdate.date"
                    ></v-date-picker>
                </v-menu>
                <v-text-field
                    v-model="actionToUpdate.title"
                    label="What to Do"
                    ref="actionTitle"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-textarea
                    v-model="actionToUpdate.description"
                    label="How to Do"
                ></v-textarea>
                <v-textarea
                    v-model="actionToUpdate.results"
                    label="Results"
                ></v-textarea>

                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateActionDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="warning"
                        @click="deleteAction"
                        v-if="actionToUpdate.id"
                        :disabled="processing"
                        >Delete</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveAction"
                        :disabled="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card></v-dialog
        >

        <v-dialog persistent v-model="updateProgressDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">{{
                    progressToUpdate.id
                        ? "Update Progress Report"
                        : "Add Progress Report"
                }}</v-card-title>
                <v-menu
                    v-model="progressToUpdate.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="progressToUpdate.date"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="progressToUpdate.date"
                    ></v-date-picker>
                </v-menu>
                <v-textarea
                    v-model="progressToUpdate.report"
                    label="Report"
                    ref="report"
                    :rules="[rules.required]"
                ></v-textarea>

                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateProgressDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        @click="saveProgressReport"
                        :loading="processing"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card></v-dialog
        >

        <v-dialog v-model="uploadDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Upload Document</v-card-title>
                <v-text-field
                    class="px-3 mb-2"
                    autocomplete="new-password"
                    label="Description"
                    ref="documentDescription"
                    :rules="[rules.required]"
                    v-model="uploadDocument.description"
                ></v-text-field>
                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2 ml-3 mb-4 mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    @change="onFilePicked($event)"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadDocumentDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="saveDocument()"
                    >
                        Save Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text
                    class="mb-2"
                    v-if="documentToDelete && documentToDelete.id"
                    >This will delete the
                    <span class="font-weight-medium">{{
                        documentToDelete.description
                    }}</span>
                    document</v-card-text
                >
                <v-card-text class="mb-2" v-if="!documentToDelete.id"
                    >This will delete the selected documents</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="
                            deleteDocumentDialog = false;
                            documentToDelete = '';
                        "
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteDocument"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDeleteProgressReportDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2 font-weight-medium"
                    >This will delete all selected progress reports</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmDeleteProgressReportDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteProgressReports"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editDialog" max-width="1000">
            <v-card
                class="pt-3"
                style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
            >
                <v-layout row class="ma-0 pa-0">
                    <v-layout column class="ma-1 px-3 mt-2">
                        <v-text-field
                            v-model="edit.mother"
                            label="Mother"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.motherCellphone"
                            label="Mother Cellphone"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.referral"
                            label="Referral"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.concern"
                            label="Concern"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.workDone"
                            label="What was done until now"
                        ></v-text-field>
                        <v-select
                            v-model="edit.workStatus"
                            label="Work Status"
                            :items="['Active', 'Inactive', 'Dismissed']"
                        ></v-select>
                        <v-combobox
                            v-model="edit.status"
                            label="Status"
                            :items="statuses"
                        ></v-combobox>
                        <v-text-field
                            v-model="edit.statusReason"
                            label="Status Reason"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.process"
                            label="Process"
                        ></v-text-field>
                    </v-layout>
                    <v-layout column class="ma-1 px-3 mt-2">
                        <v-menu
                            v-model="datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="edit.evaluationDate"
                                    label="Evaluation Date"
                                    prepend-icon="mdi-calendar"
                                    class="mb-2"
                                    v-on="on"
                                    hide-details
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="edit.evaluationDate"
                            ></v-date-picker>
                        </v-menu>
                        <v-text-field
                            v-model="edit.evaluatedBy"
                            label="Evaluated By"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.evaluationOutcome"
                            label="Evaluation Outcome"
                        ></v-text-field>

                        <v-text-field
                            v-model="edit.parentsInput"
                            label="Parents Input"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.teachersInput"
                            label="Teachers Input"
                        ></v-text-field>
                        <v-text-field
                            v-model="edit.otherRecommendations"
                            label="Other Recommendations (What else was recommended, by whom, progress)"
                        ></v-text-field>
                        <v-combobox
                            v-model="edit.provider"
                            label="Provider"
                            ref="provider"
                            :items="providers"
                            :rules="[rules.required]"
                        ></v-combobox>
                        <v-menu
                            ref="timeOfService"
                            v-model="timePickerMenu"
                            :close-on-content-click="false"
                            :return-value.sync="edit.timeOfService"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="edit.timeOfService"
                                    label="Time Of Service"
                                    class="pr-1"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                width="290"
                                v-model="edit.timeOfService"
                                @input="saveTimeOfService($event)"
                            ></v-time-picker>
                        </v-menu>
                        <v-text-field
                            v-model="edit.roomNumber"
                            label="Room Number"
                        ></v-text-field>
                    </v-layout>
                </v-layout>
                <v-card-actions class="pb-3 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="editDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="warning"
                        :loading="processing"
                        @click="unenroll"
                        >Delete</v-btn
                    >
                    <v-btn :loading="processing" color="success" @click="save()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import {
    groupBy,
    formatPhoneNumber,
    toISOLocal,
    pluralize,
    truncate,
    getDomain,
} from "../../utils/helpers.js";
import axios from "axios";
import moment from "moment";
import notes from "../components/Notes.vue";

export default {
    components: {
        notes,
    },
    data: () => ({
        student: null,
        info: "",
        processing: false,
        loading: true,
        actions: [],
        actionsToDisplay: [],

        documents: [],

        updateActionDialog: false,
        actionToUpdate: {
            id: 0,
            title: "",
            description: "",
            results: "",
            date: toISOLocal(new Date(moment())).substr(0, 10),
            datePickerMenu: false,
        },

        updateProgressDialog: false,

        progressToUpdate: {
            id: 0,
            report: "",
            date: toISOLocal(new Date(moment())).substr(0, 10),
            datePickerMenu: false,
        },

        uploadDocumentDialog: false,
        files: [],
        uploading: false,

        statuses: [],
        editDialog: false,

        uploadDocument: {
            description: "",
            action: "",
        },

        edit: {},
        datePickerMenu: false,
        timePickerMenu: false,
        providers: [],

        documentToDelete: "",
        deleteDocumentDialog: false,

        actionsPagination: {
            totalCount: 0,
            rowsPerPage: 5,
            page: 1,
        },

        progressUrl: "",
        progressReportCount: 0,
        progressActions: [],
        confirmDeleteProgressReportDialog: false,

        notesUrl: "",

        progressColumns: [
            {
                sortable: true,
                label: "Date",
                field: "date",
                hidden: false,
                type: "date",
                dateOutputFormat: "MM/DD/YYYY",
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Report",
                field: "report",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
        ],

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    computed: {
        actionsPages() {
            return this.actionsPagination.rowsPerPage
                ? Math.ceil(
                      this.actions.length / this.actionsPagination.rowsPerPage
                  )
                : 0;
        },
    },
    async created() {
        await this.load();
        await this.loadProviders();

        this.notesUrl =
            "api/specialNeedsProgram/getNotes?accountID=" +
            this.student.familyID +
            "&studentID=" +
            this.$route.params.id;

        this.progressUrl =
            "specialNeedsProgramProgress?studentID=" + this.$route.params.id;

        this.progressActions.push({
            text: "Delete Selected",
            showOnSelection: true,
            action: this.confirmDeleteProgressReport,
        });
        this.progressActions.push({
            text: "Add Progress Report",
            action: this.addProgressReport,
        });
    },
    methods: {
        async load() {
            await this.loadStudent();
            await this.loadInfo();
            await this.loadActions();
            await this.loadProgressReportCount();
            await this.loadDocuments();
        },
        async loadStudent() {
            const student = await this.$http.get(
                "api/students/getStudent?studentID=" + this.$route.params.id
            );

            this.student = student;
            this.loading = false;
        },
        async loadInfo() {
            const info = await this.$http.get(
                "api/specialNeedsProgram/getStudent?studentID=" +
                    this.$route.params.id
            );

            this.info = info;
            this.loading = false;
        },
        async loadActions() {
            const actions = await this.$http.get(
                "api/specialNeedsProgram/getActions?studentID=" +
                    this.$route.params.id
            );

            this.actions = actions;
            this.actionsToDisplay = this.actions.slice(0, 5);
        },
        async loadDocuments() {
            const documents = await this.$http.get(
                "api/specialNeedsProgram/getDocuments?studentID=" +
                    this.$route.params.id
            );

            this.documents = documents.map((d) => {
                d.date = moment(d.date).format("L");
                d.selected = false;

                return d;
            });
        },
        async loadProgressReportCount() {
            const response = await this.$http.get(
                "api/specialNeedsProgramProgress/getCount?studentID=" +
                    this.$route.params.id
            );

            this.progressReportCount = response;
        },
        addProgressReport() {
            this.updateProgressDialog = true;
        },
        editProgressReport(row) {
            this.progressToUpdate = JSON.parse(JSON.stringify(row));
            this.progressToUpdate.date = toISOLocal(new Date(row.date)).substr(
                0,
                10
            );

            this.updateProgressDialog = true;
        },
        openEditDialog() {
            this.edit.mother = this.info.mother;
            this.edit.motherCellphone = this.info.motherCellphone;
            this.edit.referral = this.info.referral;
            this.edit.concern = this.info.concern;
            this.edit.workDone = this.info.workDone;
            this.edit.status = this.info.status;
            this.edit.workStatus = this.info.workStatus;
            this.edit.statusReason = this.info.statusReason;
            this.edit.process = this.info.process;
            this.edit.evaluatedBy = this.info.evaluatedBy;
            this.edit.evaluationOutcome = this.info.evaluationOutcome;
            this.edit.parentsInput = this.info.parentsInput;
            this.edit.teachersInput = this.info.teachersInput;
            this.edit.otherRecommendations = this.info.otherRecommendations;
            this.edit.provider = this.info.provider;
            this.edit.timeOfService = this.info.timeOfService;
            this.edit.roomNumber = this.info.roomNumber;
            this.edit.evaluationDate = this.info.evaluationDate;

            this.editDialog = true;
        },
        saveTimeOfService(value) {
            this.$refs.timeOfService.save(value);
        },
        async loadProviders() {
            let providers = await this.$http.get(
                "api/specialNeedsProgram/getProviders"
            );

            providers = providers.filter(Boolean);

            if (this.isProvider()) {
                providers = [this.$store.state.authentication.user];
            }

            this.providers = providers;
        },
        isProvider() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Special Needs Provider");
        },
        setActionsPagianation() {
            if (this.getActionsSkip() >= this.actions.length) return;

            const number =
                (this.actionsPagination.page - 1) *
                this.actionsPagination.rowsPerPage;

            this.actionsToDisplay = this.actions.slice(
                number,
                number + this.actionsPagination.rowsPerPage
            );
        },
        getActionsSkip() {
            const page = this.actionsPagination.page - 1;

            let skip = page * this.actionsPagination.rowsPerPage;

            if (skip >= this.actions.length) {
                skip = this.actions.length - this.actionsPagination.rowsPerPage;
            }

            return skip;
        },
        addAction() {
            this.updateActionDialog = true;
            this.actionToUpdate.id = "";
            this.actionToUpdate.title = "";
            this.actionToUpdate.description = "";
            this.actionToUpdate.results = "";
            this.actionToUpdate.date = toISOLocal(new Date(moment())).substr(
                0,
                10
            );
        },
        updateAction(action) {
            this.actionToUpdate.id = action.id;
            this.actionToUpdate.title = action.title;
            this.actionToUpdate.description = action.description;
            this.actionToUpdate.results = action.results;
            this.actionToUpdate.date = toISOLocal(
                new Date(moment(action.date))
            ).substr(0, 10);
            this.updateActionDialog = true;
        },
        async saveAction() {
            if (!this.$refs.actionTitle.validate(true)) return;

            if (!this.actionToUpdate.date) {
                return this.$notify({
                    text: "Date Required",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/specialNeedsProgram/saveAction", {
                    id: this.actionToUpdate.id ? this.actionToUpdate.id : 0,
                    title: this.actionToUpdate.title,
                    description: this.actionToUpdate.description,
                    results: this.actionToUpdate.results,
                    date: this.actionToUpdate.date,
                    updatedBy: this.$store.state.authentication.user,
                    updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                    studentID: this.student.studentID,
                });

                this.processing = false;
                this.updateActionDialog = false;
                this.loadActions();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteAction() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/specialNeedsProgram/deleteAction?actionID=" +
                        this.actionToUpdate.id
                );

                this.processing = false;
                this.updateActionDialog = false;
                this.loadActions();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveProgressReport() {
            if (!this.$refs.report.validate(true)) return;

            if (!this.progressToUpdate.date) {
                return this.$notify({
                    text: "Date Required",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/specialNeedsProgramProgress/saveProgressReport",
                    {
                        id: this.progressToUpdate.id
                            ? this.progressToUpdate.id
                            : 0,
                        report: this.progressToUpdate.report,
                        date: this.progressToUpdate.date,
                        studentID: this.student.studentID,
                    }
                );

                this.processing = false;
                this.updateProgressDialog = false;
                this.$refs.progressGrid.load();
                this.loadProgressReportCount();
            } catch (e) {
                this.processing = false;
            }
        },
        confirmDeleteProgressReport() {
            this.confirmDeleteProgressReportDialog = true;
        },
        async deleteProgressReports() {
            try {
                this.processing = true;

                const ids = this.$refs.progressGrid
                    .getSelectedRows()
                    .map((r) => r.id);

                await this.$http.post(
                    "api/specialNeedsProgramProgress/delete",
                    ids
                );

                this.processing = false;
                this.confirmDeleteProgressReportDialog = false;
                this.$refs.progressGrid.load();
                this.loadProgressReportCount();

                this.$notify({
                    text: "Progress Reports Deleted",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        getProgressCount() {
            return this.$refs.progressGrid
                ? this.$refs.progressGrid.pagination.totalCount
                : 0;
        },
        openUploadDocumentDialog(action = null) {
            this.uploadDocumentDialog = true;
            this.uploadDocument.action = action;
        },
        closeUploadDocumentDialog() {
            this.uploadDocumentDialog = false;
            this.files = [];
        },
        getActionDocuments(action) {
            return this.documents.filter((d) => d.actionID == action.id);
        },
        pickFile() {
            this.$refs.files.click();
        },
        onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        async openDocument(doc) {
            const url = await this.$http.get(
                "/api/specialNeedsProgram/GetDocumentUrl?url=" + doc.url
            );

            window.open(url);
        },
        openDeleteDocumentDialog(doc) {
            this.documentToDelete = doc;
            this.deleteDocumentDialog = true;
        },
        openDeleteMultipleDocumentDialog() {
            this.deleteDocumentDialog = true;
        },
        allowDeleteDocument(uploadedDocument) {
            return (
                !uploadedDocument.actionID ||
                !this.actions.some((a) => a.id == uploadedDocument.actionID)
            );
        },
        async deleteDocument() {
            try {
                this.processing = true;

                const ids = this.documentToDelete.id
                    ? [this.documentToDelete.id]
                    : this.documents.filter((d) => d.selected).map((d) => d.id);

                await this.$http.post(
                    "api/specialNeedsProgram/deleteDocuments",
                    ids
                );

                this.processing = false;
                this.deleteDocumentDialog = false;
                this.documentToDelete = "";

                this.loadDocuments();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveDocument() {
            if (!this.$refs.documentDescription.validate(true)) return;

            try {
                this.processing = true;

                var formData = new FormData();

                formData.append("image", this.files[0]);

                await this.$http.post(
                    "api/specialNeedsProgram/uploadDocument?studentID=" +
                        this.student.studentID +
                        "&description=" +
                        this.uploadDocument.description +
                        "&user=" +
                        this.$store.state.authentication.user +
                        (this.uploadDocument.action &&
                        this.uploadDocument.action.id
                            ? "&actionID=" + this.uploadDocument.action.id
                            : ""),
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.processing = false;
                this.uploadDocumentDialog = false;
                this.files = [];
                this.uploadDocument.description = "";

                this.loadDocuments();
            } catch (e) {
                this.processing = false;
            }
        },
        pluralize(resource, count) {
            return pluralize(resource, count);
        },
        truncateDescription(description, length = 20) {
            return truncate(description, length);
        },
        getFileIcon(document) {
            return document.fileName.endsWith("pdf")
                ? "mdi-file-pdf"
                : this.isImage(document)
                ? "mdi-file-image"
                : "mdi-file";
        },
        getFileIconColor(document) {
            return document.fileName.endsWith("pdf") ? "red" : "#2196F3";
        },
        isImage(document) {
            return document.url.match(/.(jpg|jpeg|png|gif)$/i);
        },
        async save() {
            if (!this.$refs.provider.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/specialNeedsProgram/save", {
                    studentID: this.student.studentID,
                    familyID: this.student.familyID,
                    referral: this.edit.referral,
                    concern: this.edit.concern,
                    workDone: this.edit.workDone,
                    mother: this.edit.mother,
                    motherCellphone: this.edit.motherCellphone,
                    status: this.edit.status,
                    workStatus: this.edit.workStatus,
                    statusReason: this.edit.statusReason,
                    process: this.edit.process,
                    evaluatedBy: this.edit.evaluatedBy,
                    evaluationOutcome: this.edit.evaluationOutcome,
                    parentsInput: this.edit.parentsInput,
                    teachersInput: this.edit.teachersInput,
                    otherRecommendations: this.edit.otherRecommendations,
                    provider: this.edit.provider,
                    timeOfService: this.edit.timeOfService,
                    evaluationDate: this.edit.evaluationDate,
                    roomNumber: this.edit.roomNumber,
                    updatedBy: this.$store.state.authentication.user,
                });

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.editDialog = false;
                this.loadInfo();
            } catch (e) {
                this.processing = false;
            }
        },
        async unenroll() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/specialNeedsProgram/Unenroll?studentID=" +
                        this.student.studentID
                );

                this.$notify({
                    text: "Student Removed",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;

                this.$router.push({
                    name: "SpecialNeedsStudents",
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.spacial-needs-document {
    width: 90px;
    height: 100px;
    border: 1px solid rgb(73 90 99);
    box-shadow: rgb(199 206 216) 3px 3px 1px;
    cursor: pointer;
    border-radius: 1px;
    padding: 6px;
}
.progress-list {
    border: 1px solid #ddd !important;
}
.spacial-needs-notes .v-card {
    margin-top: 20px !important;
}
</style>
